import { createMemoryHistory } from "history";

export const history = createMemoryHistory();

export const useNavigate = () => (route: string) => {
    history.push(route);
};
